export default __webpack_public_path__ + "static/media/plus.4ce67c81.svg";